// Mock datasets for interactive interfaces (no external dependencies)

export type ChartType = "bar" | "line" | "pie";
export type ChartDatum = { label: string; value: number };

export type ChartSpec = {
  title?: string;
  type: ChartType;
  data: ChartDatum[];
  xLabel?: string;
  yLabel?: string;
};

export const salesByMonth: ChartDatum[] = [
  { label: "Jan", value: 12000 },
  { label: "Feb", value: 15000 },
  { label: "Mar", value: 18000 },
  { label: "Apr", value: 17000 },
  { label: "May", value: 21000 },
  { label: "Jun", value: 19000 },
  { label: "Jul", value: 23000 },
  { label: "Aug", value: 22000 },
  { label: "Sep", value: 25000 },
  { label: "Oct", value: 24000 },
  { label: "Nov", value: 27000 },
  { label: "Dec", value: 32000 },
];

export const inventoryByCategory: ChartDatum[] = [
  { label: "Electronics", value: 85 },
  { label: "Apparel", value: 120 },
  { label: "Home", value: 60 },
  { label: "Beauty", value: 40 },
  { label: "Sports", value: 30 },
];

export const visitsByDay: ChartDatum[] = [
  { label: "Mon", value: 1200 },
  { label: "Tue", value: 1350 },
  { label: "Wed", value: 1280 },
  { label: "Thu", value: 1600 },
  { label: "Fri", value: 2100 },
  { label: "Sat", value: 1800 },
  { label: "Sun", value: 1400 },
];

export const refundsByMonth: ChartDatum[] = [
  { label: "Jan", value: 35 },
  { label: "Feb", value: 42 },
  { label: "Mar", value: 38 },
  { label: "Apr", value: 40 },
  { label: "May", value: 44 },
  { label: "Jun", value: 39 },
  { label: "Jul", value: 36 },
  { label: "Aug", value: 41 },
  { label: "Sep", value: 37 },
  { label: "Oct", value: 45 },
  { label: "Nov", value: 48 },
  { label: "Dec", value: 50 },
];

export const outOfStockByCategory: ChartDatum[] = [
  { label: "Electronics", value: 8 },
  { label: "Apparel", value: 4 },
  { label: "Home", value: 6 },
  { label: "Beauty", value: 2 },
  { label: "Sports", value: 3 },
];
